import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  constructor(private http: HttpClient) {
  }

  getLocalizationContent(lang: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`../../../../assets/localization/${lang}.json`).subscribe({
        next: (res) => resolve(res),
        error: (err) => reject(err),
      });
    });
  }
}
